module.exports = __webpack_public_path__ + "static/media/girl.0a7ca2a2.png";